// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","footerCardsContainer":"_8goSD","left":"_3bX66","right":"ZE5rw"};